'use strict';

import config from 'config';
import Analytics from '../../analytics';

export default [
  '$http', '$window', '$location', '$state', '$interval', 'CartService', 'ErrorHandler',
  function amazonPaymentButton ($http, $window, $location, $state, $interval, cart, ErrorHandler, analytics = new Analytics()) {
    var authRequest;
    var access_token;

    // Used for upsells
    var campaignId, upsellId, orderId;
    var selectedProduct;

    function AmazonSignInCallback (orderReference, orderType) {
      var amazonReferenceId = orderReference.getAmazonOrderReferenceId();

      if (orderType === 'upsell') {
        cart.amazonCheckoutUpsellCart(amazonReferenceId, access_token, selectedProduct, campaignId, campaignId, orderId)
          .then((res) => $state.go('amazon-checkout', {
            id: res['ref_id'],
            session: amazonReferenceId,
            upsell: true,
            upsellProduct: selectedProduct,
            csl: cart.slug()
          }));
      } else {
        if (cart.size() === 0) return false;
        cart.amazonCheckoutCart(amazonReferenceId, access_token)
          .then((res) => $state.go('amazon-checkout', { id: res['ref_id'], session: amazonReferenceId, csl: cart.slug() }));
      }
    }

    function createPaymentButton (orderType) {
      new OffAmazonPayments.Button("amazon_pay_button", config['Amazon']['sellerID'], {
        type: "PwA",
        color: "Gold",
        size: "large",
        useAmazonAddressBook: true,
        authorization: function () {
          authRequest = amazon.Login.authorize({
            scope: 'profile payments:widget payments:shipping_address',
            interactive: 'always'
          }, (d) => access_token = d.access_token);
        },
        onSignIn: (orderRef) => AmazonSignInCallback(orderRef, orderType),
        onError: (error) => ErrorHandler.throwError('Amazon Sign In Error', `${error.getErrorCode()} - ${error.getErrorMessage()}`)
      });
    }

    return {
      restrict: 'E',
      replace: true,
      scope: {
        orderType: '@?',
        campaignId: '@?',
        upsellId: '@?',
        selectedProduct: '=?',
        orderId: '@?'
      },
      template: '<div id="amazon_pay_button" class="call-to-action amazon" ng-click="checkoutEvent()"></div>',
      link: (scope, element) => {
        campaignId = scope.campaignId;
        upsellId = scope.upsellId;
        orderId = scope.orderId;
        selectedProduct = scope.selectedProduct;

        let amazonInterval = $interval(() => {
          if (!$window.amazon || !$window.amazon.Login) return;
          else $interval.cancel(amazonInterval);

          $window.amazon.Login.setClientId(config['Amazon']['clientID']);
          $window.amazon.Login.setSandboxMode(config['Amazon']['sandbox']);
          createPaymentButton(scope.orderType);
        }, 250);

        // scope.checkoutEvent = () => analytics.initiateCheckout({ option: 'Amazon', upsell: (typeof upsellId != 'undefined' && upsellId !== null), cart: cart.contentsAsCampaignProducts() });
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/amazon-payment/amazon-payment.dir.js